export default __webpack_public_path__ + "static/media/ai-brain.a92112bf.svg";